var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-empty-state',{attrs:{"md-icon":"timer","md-label":"Coming Soon","md-description":"Please bear with us while we develop this feature. Stay tuned!"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }